/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * Any API response that returns a PHP pagination object will be mapped through
 * this object.
 *
 * @var {Object} paginatedResponseMap
 */
var paginatedResponseMap = {
  current_page: 'currentPage',
  data: 'data',
  embedded: 'embedded',
  from: 'from',
  last_page: 'lastPage',
  next_page_url: 'nextPageUrl',
  path: 'path',
  per_page: 'perPage',
  prev_page_url: 'prevPageUrl',
  to: 'to',
  total: 'total'
};
export default paginatedResponseMap;